import { createContractRequest } from './helper';
export const postOffer = createContractRequest({
    route: '/contract/offers',
    method: 'post',
    source: 'data',
});
